<template>
  <v-container class="travel-report-container">
    <report-filters
      :form-data="formData"
      :filter-fields="filterFields"
      :date-fields="dateFields"
      :loading="loading"
      @generate="generateReport"
      @export-excel="exportToExcel"
      @export-pdf="exportToPDF"
    />

    <report-table
      :headers="headers"
      :items="processedReport"
      :loading="loading"
      :search="search"
      @row-click="handleRowClick"
    />

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { cloneDeep } from "lodash";
import ReportFilters from "./ReportFilters.vue";
import ReportTable from "./ReportTable.vue";
import {
  INITIAL_FORM_DATA,
  TABLE_HEADERS,
  FILTER_FIELDS_CONFIG,
  DATE_FIELDS_CONFIG,
} from "./reportConstants";
import { reportMixin } from "./reportMixin";
import axios from "axios";

export default {
  name: "TravelReport",
  components: {
    ReportFilters,
    ReportTable,
  },
  mixins: [reportMixin],
  data() {
    return {
      formData: cloneDeep(INITIAL_FORM_DATA),
      loading: false,
      search: "",
      report: [],
      snackbar: {
        visible: false,
        message: "",
        color: "success",
      },
      dropdownData: {
        officeItems: [{ text: "TODOS", value: "" }],
        unitItems: [{ text: "TODOS", value: "" }],
        departmentItems: [{ text: "TODOS", value: "" }],
        resolutionItems: [{ text: "TODOS", value: "" }],
        transportItems: [{ text: "TODOS", value: "" }],
        userItems: [{ text: "TODOS", value: "" }],
        tripTypeItems: [{ text: "TODOS", value: "" }],
        statusItems: [{ text: "TODOS", value: "" }],
      },
    };
  },
  computed: {
    filterFields() {
      return FILTER_FIELDS_CONFIG.map((field) => ({
        ...field,
        items: this.dropdownData[field.itemsKey] || [],
      }));
    },
    dateFields() {
      return DATE_FIELDS_CONFIG;
    },
    headers() {
      return TABLE_HEADERS;
    },
    processedReport() {
      return this.report.map((item, index) =>
        this.processReportItem(item, index)
      );
    },
  },
  created() {
    this.initializeData();
  },
  methods: {
    async initializeData() {
      try {
        this.loading = true;
        await this.loadAllDropdownData();
        this.showSnackbar("Datos iniciales cargados", "success");
      } catch (error) {
        this.handleError("Error inicializando datos:", error);
      } finally {
        this.loading = false;
      }
    },
    async loadAllDropdownData() {
      const config = this.getRequestConfig();
      const endpoints = [
        {
          url: "oficina/listOffice",
          property: "officeItems",
          textKey: "nombre",
        },
        {
          url: "departamento/list",
          property: "departmentItems",
          textKey: "departamento",
        },
        {
          url: "usuario/allusers",
          property: "userItems",
          textKey: "nombre",
        },
        {
          url: "transporte/list",
          property: "transportItems",
          textKey: "nombre",
        },
        { url: "unidad/list", property: "unitItems", textKey: "descripcion" },
        {
          url: "resolucion/list",
          property: "resolutionItems",
          textKey: "descripcion",
        },
        { url: "estado/list", property: "statusItems", textKey: "nombre" },
      ];

      await Promise.all(
        endpoints.map(async ({ url, property, textKey }) => {
          const response = await axios.get(url, config);
          this.dropdownData[property] = [
            { text: "TODOS", value: "" },
            ...response.data.map((item) => ({
              text: item[textKey],
              value: item.id,
            })),
          ];
        })
      );

      await this.loadTripTypes(config);
    },
    async loadTripTypes(config) {
      const [nacional, internacional] = await Promise.all([
        axios.get("region_nacional/list", config),
        axios.get("region_internacional/list", config),
      ]);

      this.dropdownData.tripTypeItems = [
        { text: "TODOS", value: "" },
        ...nacional.data.map((item) => ({
          text: item.nombre,
          value: item.id,
        })),
        ...internacional.data.map((item) => ({
          text: item.nombre,
          value: item.id + 3,
        })),
      ];
    },
    processReportItem(item, index) {
      return {
        ...item,
        id: item.id || `temp-${index}-${Date.now()}`,
        userName: item.comisionado_comisionado?.usuario_usuario?.nombre || "",
        userPosition: item.comisionado_comisionado?.cargo || "",
        unitDescription: item.idunidad_unidad?.descripcion || "",
        startDate: item.fecha1,
        endDate: item.fecha2,
        location: item.lugar || "",
        transportName: item.transporte_transporte?.nombre || "",
        tripType: this.getTripType(item),
        resolution: item.resolucion_resolucion?.descripcion || "",
        totalAllowance: item.total_viatico || 0,
        totalTickets: this.calculateTotalTickets(item.pasajes),
        days: item.dias || 0,
        state: item.estado_estado?.nombre || "",
        motive: item.motivo,
        cite: item.cite || "",
      };
    },
    handleRowClick(item) {
      // Lógica para manejar clics en filas si es necesario
    },
    showSnackbar(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
  },
};
</script>

<style scoped>
.travel-report-container {
  max-width: 99%;
  margin: 0 auto;
  padding: 16px;
}
</style>
